import { computed } from 'vue'

export function useUtils(props: any): any {

  const stylingTilesDisplay = computed(() => {
    const rows = props.tiles.type === "static" ? props.tiles.dimensions.rows.max : props.tiles.dimensions.rows.current
    return {
      height:
        (rows *
          props.tiles.dimensions.rows.height) +
        props.tiles.dimensions.rows.unit,
    }
  })

  const stylingTileCalc = (top: number, left: number, height: number, width: number) => {
    const top0 =
      top * props.tiles.dimensions.rows.height +
      props.tiles.dimensions.rows.unit
    const left0 =
      left * props.tiles.dimensions.cols.width +
      props.tiles.dimensions.cols.unit
    const height0 =
      height * props.tiles.dimensions.rows.height +
      props.tiles.dimensions.rows.unit
    const width0 =
      width * props.tiles.dimensions.cols.width +
      props.tiles.dimensions.cols.unit

    const style = { top: top0, left: left0, height: height0, width: width0 }

    return style
  };

  const tilesOnForm = computed(() => {
    return props.tiles.tiles.filter((tile) => {
      return !tile.chooser
    })
  })

  const tilesRowsArray = computed(() => {
    return [...Array(props.tiles.dimensions.rows.current).keys()]
  })

  const tilesOnFormPerRow = (row: number) => {
    const r = props.tiles.tiles.filter((tile) => {
      return tile.row === row
    })
    return r
  };

  return { stylingTilesDisplay, stylingTileCalc, tilesOnForm, tilesOnFormPerRow, tilesRowsArray }
}
